import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  GET_DISTRIBUTOR_INVENTORY: "api/Distributor/Inventory",
  EXPORT: "api/Export/DistributorInventory",
}

const getDistributorInventoryList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_DISTRIBUTOR_INVENTORY, {params: data});
  return res.data;
};

const getInventoryExport = async (data: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT, { params: data, responseType: "arraybuffer" });
  return res;
};

const distributorInventory = {
  getDistributorInventoryList,
  getInventoryExport,
};

export default distributorInventory;